// extracted by mini-css-extract-plugin
export default {"container":"symbolDistribution_container__HrCGb","legends":"symbolDistribution_legends__JFqLp","title":"symbolDistribution_title__1GlqP"};